import * as React from 'react'
import styled from 'styled-components'
import { DatItem } from './DatItem'
import { DatInput } from './DatInput'
import { DatLabelText } from './DatLabelText'

const DatItemRange = styled(DatItem)`
  --dat-accent: rgba(148, 163, 184, 0.42);
`

const NumberInput = styled(DatInput)`
  flex: 0 0 72px;

  @media (max-width: 520px) {
    flex-basis: 68px;
  }
`

const RangeInput = styled.input`
  flex: 1 1 auto;
  min-width: 0;
  height: 18px;
  margin: 0;
  padding: 0;
  cursor: pointer;
  background: transparent;
  accent-color: #8fb3d9;
`

type Props = {
  value: number
  label: React.ReactNode
  min: number
  max: number
  step?: number
  disabled?: boolean
  onChange?: (value: number) => void
  onChangeStart?: (value: number) => void
  onChangeComplete?: (value: number) => void
}

export const DatRange = (props: Props) => (
  <DatItemRange>
    <DatLabelText>{props.label}</DatLabelText>

    <RangeInput
      type="range"
      min={props.min}
      max={props.max}
      value={props.value}
      onChange={event => props.onChange && props.onChange(Number(event.target.value))}
      step={props.step}
      onPointerDown={event =>
        props.onChangeStart && props.onChangeStart(Number((event.target as HTMLInputElement).value))
      }
      onPointerUp={event =>
        props.onChangeComplete && props.onChangeComplete(Number((event.target as HTMLInputElement).value))
      }
    />

    <NumberInput
      type="number"
      inputMode="numeric"
      value={props.value}
      onChange={event => typeof props.onChange === 'function' && props.onChange(Number(event.target.value))}
      disabled={props.disabled}
    />
  </DatItemRange>
)
